import * as React from "react";
import { clsx } from "clsx";
import { useErrorLog } from "../helpers/error-provider/use-log.mjs";
const getPlaceholder = (aspectRatio) => {
  if (aspectRatio) {
    return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 '.concat(aspectRatio.width, " ").concat(aspectRatio.height, '"%3E%3C/svg%3E');
  }
  return "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
};
const ImageImg = (props) => {
  var _a;
  return /* @__PURE__ */ React.createElement(
    "img",
    {
      key: (_a = props.src) != null ? _a : props.srcset,
      src: getPlaceholder(props.aspectRatio),
      "data-src": props.src,
      "data-srcset": props.srcset,
      "data-sizes": props.srcset ? "auto" : void 0,
      className: clsx(
        "image",
        "lazyload",
        {
          ["image--".concat(props.shape)]: !!props.shape,
          ["image--".concat(props.align)]: !!props.align,
          ["image--inactive"]: !!props.isInactive,
          ["image--no-fade"]: !!props.noFade
        },
        props.className
      ),
      alt: props.role === "presentation" ? "" : props.alt,
      width: props.width,
      onError: props.onError,
      onLoad: props.onLoad,
      style: props.style,
      ref: props.imageRef
    }
  );
};
const ImagePicture = (props) => {
  return /* @__PURE__ */ React.createElement("picture", { className: props.pictureClassName }, props.sources.map((item) => {
    return /* @__PURE__ */ React.createElement(
      "source",
      {
        key: item.srcset,
        srcSet: item.aspectRatio && getPlaceholder(item.aspectRatio),
        "data-srcset": item.srcset,
        media: "(min-width: ".concat(item.minWidth, ")")
      }
    );
  }), /* @__PURE__ */ React.createElement(ImageImg, { ...props }));
};
const Image = (props) => {
  const { role, alt, src, sources, srcset } = props;
  const { log } = useErrorLog();
  React.useEffect(() => {
    if (role !== "presentation" && !alt) {
      const srcIndentifier = src ? "src: ".concat(src) : void 0;
      const srcSetIndentifier = srcset ? "srcset: ".concat(srcset) : void 0;
      log("react-front: image is missing required alt prop (".concat(srcSetIndentifier != null ? srcSetIndentifier : srcIndentifier, ")"));
    }
  }, [role, alt, src, srcset, log]);
  return sources ? /* @__PURE__ */ React.createElement(ImagePicture, { ...props, sources }) : /* @__PURE__ */ React.createElement(ImageImg, { ...props });
};
export {
  Image
};
